import { conduitApiFetch, ConduitApiBaseUrl } from "./fetch";

export default class ConduitApiActions {
  static getOverrideActions({ actionGroupId, sequenceId }) {
    const variable = sequenceId
      ? `sequence_id=${sequenceId}`
      : actionGroupId
        ? `action_group_id=${actionGroupId}`
        : null;
    if (!variable) throw Error("sequence_id or action_group_id is required");
    return conduitApiFetch(`${ConduitApiBaseUrl}actions/rf_override?use_defaults=true&${variable}`);
  }
}
